import React from "react";
import ReviewTable from "../../../components/ReviewTable";
import { formItems } from "../../../shared/informationRequest/informationRequestConfiguration";
import ReviewQuestion from "../utils/ReviewQuestion";

const ReviewAnswers = ({ configuration, form }) => {
  const { responses, documentUploads, showPrevious } = form;
  const { fieldsByIdentifier, itemIdentifiers } = formItems(configuration);

  return (
    <ReviewTable>
      <thead>
        <tr>
          <th>We asked</th>
          <th>Your answer</th>
        </tr>
      </thead>
      <tbody>
        {itemIdentifiers.map((name) => {
          const fieldConfig = fieldsByIdentifier.get(name);
          return (
            <ReviewQuestion
              doableConfig={configuration}
              fieldConfig={fieldConfig}
              responses={responses}
              key={name}
              responseToQuestion={responses[name]}
              uploads={documentUploads[name]}
              showPrevious={showPrevious}
            />
          );
        })}
      </tbody>
    </ReviewTable>
  );
};

export default ReviewAnswers;
